/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Eyebrow_TrendInputs */

const en_directory_ai_tools_eyebrow_trend = /** @type {(inputs: Directory_Ai_Tools_Eyebrow_TrendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The trend`)
};

const zh_directory_ai_tools_eyebrow_trend = /** @type {(inputs: Directory_Ai_Tools_Eyebrow_TrendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`趋势由来`)
};

/**
* | output |
* | --- |
* | "The trend" |
*
* @param {Directory_Ai_Tools_Eyebrow_TrendInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_eyebrow_trend = /** @type {((inputs?: Directory_Ai_Tools_Eyebrow_TrendInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Eyebrow_TrendInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_eyebrow_trend(inputs)
	return zh_directory_ai_tools_eyebrow_trend(inputs)
});
export { directory_ai_tools_eyebrow_trend as "directory.ai_tools.eyebrow.trend" }